import { Controller } from "stimulus"

export default class extends Controller {
    static targets = ["activeCheckbox", "reasonWrapper", "reasonSelect", "customReasonWrapper", "customReasonInput", "statusReasonInput"]

    connect() {
        this.refresh()
    }

    refresh() {
        this.toggleReasonVisibility()
        this.toggleCustomReasonVisibility()
        this.prepareStatusReason()
    }

    toggleReasonVisibility() {
        // Show reason block only when deactivating (checkbox unchecked)
        if (!this.activeCheckboxTarget.checked) {
            this.reasonWrapperTarget.classList.remove("is-hidden")
        } else {
            this.reasonWrapperTarget.classList.add("is-hidden")
            this.customReasonWrapperTarget.classList.add("is-hidden")
        }
    }

    toggleCustomReasonVisibility() {
        if (this.activeCheckboxTarget.checked) {
            this.customReasonWrapperTarget.classList.add("is-hidden")
            return
        }

        if (this.reasonSelectTarget.value === "Autre") {
            this.customReasonWrapperTarget.classList.remove("is-hidden")
        } else {
            this.customReasonWrapperTarget.classList.add("is-hidden")
        }
    }

    prepareStatusReason() {
        if (this.activeCheckboxTarget.checked) {
            this.statusReasonInputTarget.value = ""
            return
        }

        if (this.reasonSelectTarget.value === "Autre") {
            this.statusReasonInputTarget.value = this.customReasonInputTarget.value.trim()
            return
        }

        this.statusReasonInputTarget.value = this.reasonSelectTarget.value
    }
}
